"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveContractPriceSchema = exports.terminateContractSchema = exports.createContractSchema = exports.CONTRACT_TYPES = void 0;
const zod_1 = require("zod");
exports.CONTRACT_TYPES = ['CORPORATE', 'INSURANCE', 'GOVERNMENT', 'TPA', 'NGO', 'HOSPITAL_TIE_UP'];
exports.createContractSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(255),
    contractType: zod_1.z.enum(exports.CONTRACT_TYPES),
    payerId: zod_1.z.string().uuid().optional(),
    priceListId: zod_1.z.string().uuid().optional(),
    commercialRuleId: zod_1.z.string().uuid().optional(),
    taxOverridePercent: zod_1.z.number().min(0).max(100).optional(),
    marginFloorPercent: zod_1.z.number().min(0).max(100).optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
    remarks: zod_1.z.string().optional(),
});
exports.terminateContractSchema = zod_1.z.object({ reason: zod_1.z.string().min(1) });
exports.resolveContractPriceSchema = zod_1.z.object({
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    asOfDate: zod_1.z.coerce.date().optional(),
});
//# sourceMappingURL=contract.schema.js.map